import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelSalesApiInterface, FunnelSalesSwrInterface } from 'modules/funnels/funnel/components/sales-tab/types/funnel-sales-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useFunnelSales(t0) {
  const $ = _c(9);
  const {
    limit,
    pagination,
    filter,
    funnelId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ""}${filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== funnelId || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${FUNNELS_API}/${funnelId}/sales?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${FUNNELS_API}/${funnelId}/sales?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[1] = filterApi;
    $[2] = funnelId;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: sales
  } = useSWR(t2, fetcher);
  let t3;
  if ($[7] !== sales) {
    t3 = {
      sales
    };
    $[7] = sales;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}